import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { iframeUrl } from 'src/app/core/constant/iframeUrls';

@Component({
  selector: 'app-create-user',
  templateUrl: './create-user.component.html',
  styleUrls: ['./create-user.component.scss']
})
export class CreateUserComponent implements OnInit {
  iframeUrlCreateUserRaw: any;

  constructor(
    private sanitizer: DomSanitizer,
    private router: Router,
  ) {

  }

  ngOnInit(): void {
    let iframeUrlCreateUserRaw = iframeUrl.createUser.url;
    this.iframeUrlCreateUserRaw = this.sanitizer.bypassSecurityTrustResourceUrl(iframeUrlCreateUserRaw);
  }

  BackToDashboard() {
    this.router.navigate(['dashboard']);
  }
}
